import React from 'react';
import { Table, Typography } from 'antd';
import dayjs from 'dayjs';
import type { ExpV2StateLogRow } from '@/types/experimentsV2';
import { CopyableId } from '@/components/CopyableId';
import { actionLabel } from './actions';

const json = (v?: Record<string, unknown> | null) =>
  v && Object.keys(v).length > 0 ? JSON.stringify(v) : '';

/** Every lifecycle change, newest first. */
export const StateLogTable: React.FC<{ rows: ExpV2StateLogRow[] }> = ({ rows }) => {
  const sorted = [...rows].sort((a, b) => b.at.localeCompare(a.at));
  return (
    <Table<ExpV2StateLogRow>
      size="small"
      rowKey="id"
      dataSource={sorted}
      pagination={{ pageSize: 20, hideOnSinglePage: true }}
      columns={[
        {
          title: 'When',
          dataIndex: 'at',
          render: (v: string) => dayjs(v).format('D MMM HH:mm:ss'),
        },
        { title: 'Action', dataIndex: 'action', render: (v: string) => actionLabel(v) },
        { title: 'Variant', dataIndex: 'variant', render: (v?: string) => v ?? '' },
        {
          title: 'Change',
          key: 'change',
          render: (_: unknown, r: ExpV2StateLogRow) => {
            const from = json(r.oldValue);
            const to = json(r.newValue);
            if (!from && !to) return '';
            return (
              <Typography.Text code style={{ fontSize: 12 }}>
                {from || '-'} → {to || '-'}
              </Typography.Text>
            );
          },
        },
        {
          title: 'Admin',
          dataIndex: 'adminId',
          render: (v?: string) => (v ? <CopyableId value={v} /> : 'system'),
        },
      ]}
    />
  );
};
